<template>
  <table class="table">
    <tbody>
      <tr>
        <td class="table-label">Energy</td>
        <td colspan="1" v-if="gasData">Gas</td>
        <td v-if="electricityData">Electricity</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Annual Consumption</td>
        <td colspan="1" v-if="gasData">{{ gasData.annualUsage | number }} <small>kWh</small></td>
        <td v-if="electricityData">{{ electricityData.annualUsage | number }} <small>kWh</small></td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Date of Calculation</td>
        <td colspan="1" v-if="gasData">{{ gasData.dateOfCalculation | date }}</td>
        <td v-if="electricityData">{{ electricityData.dateOfCalculation | date }}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Supplier</td>
        <td colspan="1" v-if="gasData">{{ gasData.supplier }}</td>
        <td v-if="electricityData">{{ electricityData.supplier }}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Tariff</td>
        <td colspan="1" v-if="gasData">{{ gasData.tariffName }}</td>
        <td colspan="1" v-if="electricityData">{{ electricityData.tariffName }}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Tariff End Date</td>
        <td colspan="1" v-if="gasData">{{ gasData.tariffEndDate | date }}</td>
        <td v-if="electricityData">{{ electricityData.tariffEndDate | date }}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Days left on current tariff</td>
        <td colspan="1" v-if="gasData">{{ gasData.daysLeftOnCurrentTariff }}</td>
        <td v-if="electricityData">{{ electricityData.daysLeftOnCurrentTariff }}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Standing Charge</td>
        <td colspan="1" v-if="gasData">{{ gasData.standingCharge }} <small>p/day</small></td>
        <td v-if="electricityData">{{ electricityData.standingCharge }} <small>p/day</small></td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Unit rate <small>(p/kWh)</small></td>
        <td colspan="1" v-if="gasData">{{ gasData.unitRate }}</td>
        <td v-if="electricityData">
          <div v-if="!electricityData.unitRateNight">
            {{ electricityData.unitRateDay }}
          </div>
          <div class="row" v-if="electricityData.unitRateNight">
            <div class="col-xs-6">
              <div>
                {{ electricityData.unitRateDay }}
              </div>
              <small>Day</small>
            </div>

            <div class="col-xs-6">
              <div>
                {{ electricityData.unitRateNight }}
              </div>
              <small>Night</small>
            </div>
          </div>
        </td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Discounts</td>
        <td colspan="1" v-if="gasData">{{ gasData.discounts | currency(2)}}</td>
        <td v-if="electricityData">{{ electricityData.discounts | currency(2)}}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Cost of current tariff</td>
        <td colspan="1" v-if="gasData && newTariff">{{ gasData.nextTwelveMonthsWithVat | currency(2)}}</td>
        <td v-if="electricityData && newTariff">{{ electricityData.nextTwelveMonthsWithVat | currency(2)}}</td>

        <td colspan="1" v-if="gasData && !newTariff">{{ gasData.previousTwelveMonthsWithVat | currency(2)}}</td>
        <td v-if="electricityData && !newTariff">{{ electricityData.previousTwelveMonthsWithVat | currency(2)}}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Exit Fees</td>
        <td colspan="1" v-if="gasData">{{ gasData.terminationFees | currency(2)}}</td>
        <td v-if="electricityData">{{ electricityData.terminationFees | currency(2)}}</td>
      </tr>

      <tr>
        <td class="table-label" style="width:40%;">{{ !(standardTariffGas || standardTariffElectricity) ? 'Personal Projection' : 'Remaining Cost of Fixed Price Tariff' }}</td>

        <td colspan="1" v-if="gasData"><strong>{{ gasData.personalProjection | currency(2)}}</strong></td>
        <td v-if="electricityData"><strong>{{ electricityData.personalProjection | currency(2)}}</strong></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'PppTable',
  props: {
    newTariff: {
      type: Boolean,
      default: false
    },
    gasData: Object,
    electricityData: Object,
    standardTariffGas: Object,
    standardTariffElectricity: Object,
    showMore: {
      type: Boolean,
      default: []
    }
  }
};
</script>

<style lang="scss" src="./ppp-table.scss"></style>
